import './index.scss';
export default function ZoomTransition() {
	return <div className="zoomTransitionContainer" />;
}
